import { SeatsSync } from 'features/PunchupPages/SeatsSync';

// No frontend token inspection here on purpose: super-admin is enforced
// server-side by every /internal/* endpoint. Normal login tokens don't carry
// the isSuperAdmin claim, so a frontend claim check locks out operators the
// backend would accept. Without access the status call 403s and the table
// shows its error state.
const SeatsSyncPage = (): JSX.Element => <SeatsSync />;

export default SeatsSyncPage;
